var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.731,23.5c-3.392,0-6.15,2.759-6.15,6.15c0,1.942,0.905,3.678,2.315,4.806l-4.625,12.981 c-2.021-0.047-3.792,0.919-4.931,2.387l-8.571-2.908c-0.014-3.38-2.767-6.125-6.15-6.125c-3.391,0-6.15,2.759-6.15,6.15 c0,1.53,0.562,2.932,1.489,4.009l-5.479,9.368c-0.391-0.078-0.796-0.119-1.21-0.119c-3.392,0-6.151,2.759-6.151,6.15 s2.759,6.15,6.151,6.15c3.391,0,6.15-2.759,6.15-6.15c0-1.53-0.562-2.932-1.489-4.009l5.479-9.368 c0.391,0.078,0.796,0.119,1.21,0.119c1.976,0,3.736-0.937,4.862-2.389l8.571,2.908c0.014,3.38,2.768,6.126,6.151,6.126 c3.392,0,6.15-2.759,6.15-6.15c0-1.942-0.905-3.678-2.315-4.805l4.625-12.981c0.022,0,0.045,0,0.067,0 c3.392,0,6.15-2.759,6.15-6.151C73.882,26.259,71.123,23.5,67.731,23.5z M28.269,68.5c-1.186,0-2.151-0.965-2.151-2.15 s0.965-2.15,2.151-2.15c1.186,0,2.15,0.965,2.15,2.15S29.454,68.5,28.269,68.5z M39.619,49.092c-1.186,0-2.15-0.965-2.15-2.15 s0.965-2.15,2.15-2.15s2.15,0.965,2.15,2.15S40.805,49.092,39.619,49.092z M59.204,55.737c-1.187,0-2.151-0.965-2.151-2.15 s0.965-2.15,2.151-2.15c1.186,0,2.15,0.965,2.15,2.15S60.39,55.737,59.204,55.737z M67.731,31.801c-1.186,0-2.15-0.965-2.15-2.151 c0-1.186,0.965-2.15,2.15-2.15s2.15,0.965,2.15,2.15C69.882,30.836,68.917,31.801,67.731,31.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramLine);
export default __webpack_public_path__ + "static/media/diagram-line.d064fb757b34b4fdaed71abffab37472.svg";
export { ForwardRef as ReactComponent };